class TSTimer extends HTMLElement {
  constructor() {
    super();
    this.endDate = "";
    this.type = this.dataset.timer;
    this.cancelAction = this.dataset.action;
    this.timeTarget = this.dataset.target;
    this.cells = ["days","hours","minutes","seconds"];
  }

  connectedCallback() {
    switch (this.type) {
      case "cancel_date":
        this.endDate = this.parseDateInput(this.timeTarget);
        break;
      case "cancel_time":
        const targetMinutes = parseInt(this.timeTarget);
        this.endDate = new Date(Date.now() + targetMinutes * 60 * 1000).getTime();
        break;
      case "daily":
        this.endDate = new Date().setHours(23, 59, 59);
        break;
    }

    this.sessionStorageKey = `ts-timer-bar-${this.dataset.block}`;    

    if (sessionStorage.getItem(this.sessionStorageKey) === "true") {
      this.hideTimer();
    }

    this.timerInterval = setInterval(this.updateTimer.bind(this), 500);
    this.updateTimer();

    const section = this.closest('[id^="shopify-section-"]');
    if (section.querySelector("[data-close]")) {
      console.log("CLOSE");
      
      section.querySelector("[data-close]").addEventListener("click", () => {
        console.log("CLOSE");
        this.hideTimer();
      })
    }
  }

  updateTimer() {
    const now = new Date().getTime();
    const timeDiff = this.endDate - now;

    if (timeDiff <= 0) {
      clearInterval(this.timerInterval);

      if (this.cancelAction === "hide") {      
        this.hideTimer();
      }
      return;
    }

    const params = {
      days: Math.floor(timeDiff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeDiff % (1000 * 60)) / 1000)
    }
    
    // this.cells.forEach(attribute => {
    //   this.querySelector(`[data-cell="${attribute}"]`).textContent = String(params[attribute]).padStart(2, '0')
    // })

    this.cells.forEach(attribute => {
      const cell = this.querySelector(`[data-cell="${attribute}"]`);
      if (!cell) return;

      const digits = String(params[attribute]).padStart(2, '0').split('');
      const spans = cell.querySelectorAll('span');

      spans.forEach((span, index) => {
        span.textContent = digits[index] ?? '';
      });
    });
  }

  hideTimer() {
    this.closest('[id^="shopify-section-"]').style.display = "none";
    sessionStorage.setItem(this.sessionStorageKey, "true");
  }

  getEndOfDayTimestampLA() {
    const laDateParts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());

    const y = laDateParts.find(p => p.type === "year").value;
    const m = laDateParts.find(p => p.type === "month").value;
    const d = laDateParts.find(p => p.type === "day").value;

    const endOfDayLA = new Date(`${y}-${m}-${d}T23:59:59.999-08:00`);

    return endOfDayLA.getTime();
  }


  parseDateInput(dateStr) {
    const [datePart, timePart] = dateStr.trim().split(" ");
    const [day, month, year] = datePart.split("-").map(Number);

    let hours = 0, minutes = 0;
    if (timePart) {
      [hours, minutes] = timePart.split(":").map(Number);
    }

    const utcTimestamp = new Date(Date.UTC(year, month - 1, day, hours, minutes)).getTime();
    
    return utcTimestamp + 8 * 60 * 60 * 1000; 
  }
}

customElements.define("ts-timer", TSTimer);